if (!customElements.get('parallax-image')) {
    class ParallaxImage extends HTMLElement {
        constructor() {
            super();
            this.factor = 0;
        }

        connectedCallback() {
            this.init();
        }

        init() {
            this.image = this.querySelector('img');

            if(!this.image) return;

            this.moveUp = this.image.dataset.direction === 'enable_dynamic_up';
            this.imageAspectRatio = this.image.dataset.aspectRatio;
            
            this.calculateSize();
            this.calculateScroll();

            this.onResizeHandler = this.onResize.bind(this);
            this.onScrollHandler = this.onScroll.bind(this);

            const animationStep = () => {
                this.onScrollHandler();
                window.requestAnimationFrame(animationStep);
            };
    
            window.requestAnimationFrame(animationStep);
            window.addEventListener('resize', this.onResizeHandler);
            this.querySelector('img').addEventListener('load', this.onResizeHandler, {once: true});
            this.classList.add('parallax-image--init')
        }

        onResize() {
            this.calculateSize();
            this.calculateScroll();
        }

        onScroll() {
            this.calculateScroll();
        }

        calculateSize() {
            const containerParams = this.getBoundingClientRect();
            const imageHeight = containerParams.width / this.imageAspectRatio;
            this.imageStroke = imageHeight - containerParams.height;
            this.factorBody = imageHeight / 100 * this.factor;
            this.scrollStroke = window.innerHeight + containerParams.height;
            this.imageScrollRatio = (this.imageStroke + this.factorBody * 2) / this.scrollStroke;
            this.lastScroll = null;
        }

        calculateScroll() {
            const scrollTop = themeBase.scrollTop;

            if(scrollTop === this.lastScroll) return;
            if(this.imageStroke > 0) {
                const containerParams = this.getBoundingClientRect();
                
                if(containerParams.bottom < 100 || containerParams.top > themeBase.windowHeight + 100) return;
                this.classList.add('parallax-image--enable');

                let setTop = containerParams.bottom * this.imageScrollRatio;

                if(this.moveUp) {
                    setTop = this.imageStroke - setTop;
                }
                if(containerParams.bottom >= this.factorBody && containerParams.bottom <= this.scrollStroke - this.factorBody) {
                    this.image.style.transform = `translateY(${setTop * -1 + this.factorBody}px)`;
                }

                if(!this.animateClassTimeout) {
                    this.animateClassTimeout = setTimeout(() => this.classList.add('parallax-image--animate'), 10);
                }
            } else {
                this.classList.remove('parallax-image--enable');
                this.image.removeAttribute('style');
                if(this.animateClassTimeout) {
                    clearTimeout(this.animateClassTimeout);
                    this.animateClassTimeout = null;
                }
            }

            this.lastScroll = scrollTop;
        }

        disconnectedCallback() {
            window.removeEventListener('resize', this.onResizeHandler);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
    }

    customElements.define('parallax-image', ParallaxImage);
}